import React from 'react';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import styled from 'styled-components';


function AutofillButton({ onClick }) {
    return (
        <StyledButton
            type="button"
            onClick={onClick}
        >
            {'Autofill'}
        </StyledButton>
    );
}

AutofillButton.propTypes = {
    onClick: PropTypes.func.isRequired,
};

const StyledButton = styled.button`
    position: fixed;
    top: 48px;
    left: 0;
    z-index: 9999;
`;

export default observer(AutofillButton);